import { chunk, last } from 'lodash-es';

export async function waitAsync(ms: number): Promise<void> {
	return new Promise((res) => setTimeout(res, ms));
}

export async function processPromisesInChunks<T = () => Promise<void>, R = void>(
	itemsToProcess: T[],
	funcToProcess: (item: T) => Promise<R>,
	chunkSize = 50,
	delayBetweenChunks = 0
): Promise<Array<R>> {
	let allResults: R[] = [];
	const chunks = chunk(itemsToProcess, chunkSize);
	const lastChunk = last(chunks);

	for (const chunk of chunks) {
		const chunkResults = await Promise.all(chunk.map(async (item) => funcToProcess(item)));

		if (delayBetweenChunks && chunk !== lastChunk) {
			await waitAsync(delayBetweenChunks);
		}

		allResults = [...allResults, ...chunkResults];
	}

	return allResults;
}

export async function proccessPromisesByPortions<T = () => Promise<void>, R = void>(
	itemsToProcess: Array<T>,
	funcToProcess: (portion: Array<T>) => Promise<R>,
	portionSize = 50,
	delayBetweenPortions = 0
): Promise<Array<R>> {
	let allResults: Array<R> = [];
	const portions = chunk(itemsToProcess, portionSize);
	const lastPortion = last(portions);

	for (const portion of portions) {
		const portionResults = await funcToProcess(portion);

		if (delayBetweenPortions && portion !== lastPortion) {
			await waitAsync(delayBetweenPortions);
		}

		allResults = [...allResults, portionResults];
	}

	return allResults;
}
